$(document).ready(function () {
	if (!$(".searcher-icon").length) {
		$("#searcher-modal").remove();
	}
});